export const StatusBadge = ({ status }) => {
  const config = {
    pending: { bg: "#fef3c7", text: "#b45309", label: "Pending" },
    success: { bg: "#d1fae5", text: "#047857", label: "Success" },
    error: { bg: "#fee2e2", text: "#b91c1c", label: "Failed" },
  };
  const { bg, text, label } = config[status] || config.pending;

  return (
    <span
      style={{
        backgroundColor: bg,
        color: text,
        fontSize: "12px",
        fontWeight: "300",
        padding: "4px 10px",
        borderRadius: "9999px",
      }}
    >
      {label}
    </span>
  );
};
